import { render, staticRenderFns } from "./MemberCollection.vue?vue&type=template&id=26ea4eb7&scoped=true&"
import script from "./MemberCollection.vue?vue&type=script&lang=js&"
export * from "./MemberCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea4eb7",
  null
  
)

export default component.exports